var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 2C8.76875 2 2.5 8.26875 2.5 16C2.5 23.7313 8.76875 30 16.5 30C24.2313 30 30.5 23.7313 30.5 16C30.5 8.26875 24.2313 2 16.5 2ZM21.6688 21.3188L19.6063 21.3094L16.5 17.6063L13.3969 21.3062L11.3313 21.3156C11.1938 21.3156 11.0813 21.2062 11.0813 21.0656C11.0813 21.0062 11.1031 20.95 11.1406 20.9031L15.2063 16.0594L11.1406 11.2188C11.1029 11.1729 11.0819 11.1156 11.0813 11.0562C11.0813 10.9187 11.1938 10.8062 11.3313 10.8062L13.3969 10.8156L16.5 14.5188L19.6031 10.8188L21.6656 10.8094C21.8031 10.8094 21.9156 10.9187 21.9156 11.0594C21.9156 11.1187 21.8938 11.175 21.8563 11.2219L17.7969 16.0625L21.8594 20.9062C21.8969 20.9531 21.9188 21.0094 21.9188 21.0688C21.9188 21.2063 21.8063 21.3188 21.6688 21.3188Z",
    fill: "#FF4D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.1293ee73192b408cf4cac6802228ab7f.svg";
export { ForwardRef as ReactComponent };